import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { City } from 'src/app/modules/entities/city';
import { Person } from 'src/app/modules/entities/person';
import { PersonService } from 'src/app/modules/services/person.service';
import { environment } from 'src/environments/environment.development';
import { url } from 'src/app/modules/util/constants';
import { CityService } from 'src/app/modules/services/city.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router, private cookies: CookieService, private personService: PersonService, private cityService: CityService) { }

  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + '/thumbnails/';
  personByCity: { [key: string]: Person[] } = {};
  cities: City[] = [];

  ngOnInit(): void {
    this.getVisibleCities();
  }

  getVisibleCities() {
    this.cityService.getCities().subscribe(response => {
      if (response.status === 'success') {
        this.cities = response.data.filter(city => city.visible === 1);
        this.cookies.set('cities', JSON.stringify(response.data));
      }
    });
  }

  goToProfile(urlId: string) {
    this.router.navigate([url['perfil'], urlId]);
  }

  navigatePersonList() {
    if (this.cookies.check('navigationCity')) {
      this.router.navigate([url['lista-perfiles'], this.cookies.get('navigationCity')]);
    } else {
      this.router.navigate([url['lista-perfiles']]);
    }
  }

  getCityUrl(citySearchName: string): string {
    return '/' + url['lista-perfiles'] + '/' + citySearchName;
  }

  getUrl(pageId: string): string {
    return '/' + url[pageId];
  }

  navigateRegister() {
    this.router.navigate([url['registro-1']]);
  }
}
